













































































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {
  DeleteResultModel,
  RateRuleEditModel,
  RateRuleSortOrderEditModel,
  RateRuleViewModel
} from '@/services/api/nswag/stapiclient_generated';
import RateRuleEdit from '@/views/RateRules/RateRuleEdit.vue';
import {stRateRuleApi} from '@/services/st-api';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
    RateRuleEdit, RateRuleItem
  },
})
export default class RateRuleItem extends Vue {
  @Prop() parentRateRule!: RateRuleViewModel;

  get currency() {
    return UserStore.userSettings.currency;
  }

  get rateRules() {
    return this.parentRateRule.childRateRules;
  }

  set rateRules(value) {
    value?.forEach((x, index) => {
      x.sortOrder = index + 1;
    });

    const models = value?.map(x => {
      const item: RateRuleSortOrderEditModel = RateRuleSortOrderEditModel.fromJS({id: x.id, sortOrder: x.sortOrder})
      return item;
    });

    if (models) {
      stRateRuleApi.updateSortOrder(models);
    }

    this.parentRateRule.childRateRules = value;
  }

  get parentIsGlobalRule() {
    return this.parentRateRule.isGlobal;
  }

  editModeAnyChild(rateRules: RateRuleViewModel[] | null | undefined): boolean {
    return rateRules?.some(x => x.editMode || this.editModeAnyChild(x.childRateRules)) ?? false;
  }

  sortDisabled(rateRules: RateRuleViewModel[] | null | undefined) {
    return this.editModeAnyChild(rateRules)
        || rateRules?.length == 1;
  }

  firstColumnHeader(item: RateRuleViewModel) {
    if (item.customerNames && item.customerNames.length > 0) {
      return {type: 'customers', data: item.customerNames, icon: 'far fa-address-card'};
    }

    return {type: 'customers', data: [{name: this.$t('Alle Kunden')}], icon: 'far fa-address-card'};
  }

  secondColumnHeader(item: RateRuleViewModel) {
    if (item.projectTaskNames && item.projectTaskNames.length > 0) {
      return {type: 'projectTasks', data: item.projectTaskNames, icon: 'far fa-lightbulb'};
    }

    return {type: 'projectTasks', data: [this.$t('Alle Leistungen')], icon: 'far fa-lightbulb'};
  }

  thirdColumnHeader(item: RateRuleViewModel) {
    if (item.appUserNames && item.appUserNames.length > 0) {
      return {type: 'appUsers', data: item.appUserNames, icon: 'far fa-user'};
    }
    return {type: 'appUsers', data: [this.$t('Alle Mitarbeiter')], icon: 'far fa-user'};
  }

  async deleteItem(id: number): Promise<DeleteResultModel> {
    try {
      const resp = (await stRateRuleApi.delete(id));

      if (resp.confirmationNeeded) {
        return resp;
      }

      this.$emit('reload');
      return resp;
    } finally {
    }
  }

  async getNewRule(parentRateRule: RateRuleViewModel) {
    let item: RateRuleEditModel = (await stRateRuleApi.getNew(parentRateRule.id!));
    parentRateRule.newRateRuleEditMode = true;
    parentRateRule.newRateRuleEditModel = item;
  }

  async loadEditModel(rateRule: RateRuleViewModel) {
    let item: RateRuleEditModel = (await stRateRuleApi.get(rateRule.id!));

    rateRule.editMode = true;
    rateRule.editModel = item;
  }
}
